import HorizontalMenu from "../components/horizontalMenu";
import React, { useState } from 'react';
import axiosInstance from "../utils/axiosInstance";
import Button from "react-bootstrap/esm/Button";
import { useLocation } from 'react-router-dom';

function EditUser() {
    const locationReact = useLocation();
    
    const { profileName, userLocation } = locationReact.state || {};
    const [location, setLocation] = useState(userLocation);
    const [displayName, setDisplayName] = useState(profileName);

    const handleInputChange = (e) => {
        const {id, value} = e.target;
        
        if (id === "location") {
          setLocation(value); 
        } if (id === "displayName") {
          setDisplayName(value); 
        }
      };
    
    
    
      const handleSubmit = async (e) => {
        e.preventDefault();
    
        try {
         const response = await axiosInstance.put('/users/user', { 'location': location, 'displayName': displayName });
         
        } catch (err) {
          
        }
      };


    return (
        <div>
            <HorizontalMenu></HorizontalMenu>
          <h2>Edit Profile</h2>
          <form onSubmit={handleSubmit}>
           
            <div>
            <label htmlFor="displayName">Display Name:</label>
              <input type="text" 
              id="displayName" 
              value={displayName}
              placeholder="Enter a display name for your profile" 
              onChange={handleInputChange}></input>
              <label htmlFor="location">Location:</label>
              <input
                type="text"
                id="location"
                value={location}
                onChange={handleInputChange}
  
                placeholder="Enter your location"
              />
            </div>
            <Button type="submit">Update Profile</Button>
          </form>
    
          
        </div>
      );

    

}

export default EditUser;